export default {
  TeamFilter: () => import('@/components/base-components/TeamFilter.vue'),
  TeamGroupFilter: () => import('@/components/base-components/TeamGroupFilter.vue'),
  CategoryFilter: () => import('@/components/base-components/CategoryFilter.vue'),
  LocationFilter: () => import('@/components/base-components/Filters/LocationFilter.vue'),
  GenderFilter: () => import('@/components/base-components/Filters/GenderFilter.vue'),
  passCard: () => import('@/league/components/main/PassComponent.vue'),
  passCardFromTable: () => import('@/league/components/main/PassCardFromTableData.vue'),
  passTable: () => import('@/components/base-components/Packages/PassTable.vue'),

  // IMAGES
  CAD_FLAG: () => import('@/assets/img/flags/CanadaFlag.vue'),
  GB_FLAG: () => import('@/assets/img/flags/GreatBritainFlag.vue'),
  FR_FLAG: () => import('@/assets/img/flags/FranceFlag.vue'),
  BG_FLAG: () => import('@/assets/img/flags/BulgarianFlag.vue'),
  US_FLAG: () => import('@/assets/img/flags/UsaFlag.vue'),
};
